var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"form-group"},[_c('label',[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_c('input',_vm._b({class:_vm.classes,attrs:{"name":_vm.name},domProps:{"value":_vm.value},on:{"input":_vm.input}},'input',_vm.$attrs,false)),_c('div',{staticClass:"errorMess"},[_vm._v(_vm._s(_vm.error))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }